import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const stats = [{
  value: '200+',
  label: 'Talleres Transformados'
}, {
  value: '3x',
  label: 'Más Clientes en 90 Días'
}, {
  value: '5★',
  label: 'Calificación Promedio en Google'
}, {
  value: '$2M+',
  label: 'Generados para Nuestros Clientes'
}];
const testimonials = [{
  quote: 'Antes de Doctor Ecommerce, tenía 3 bahías vacías al día. Ahora tengo lista de espera.',
  author: 'Carlos M.',
  business: 'Taller AutoPro, Miami'
}, {
  quote: 'En 60 días pasamos de 15 a 40 clientes semanales. El ROI fue brutal.',
  author: 'Roberto S.',
  business: 'MecánicaExpress, Houston'
}, {
  quote: 'Por fin aparecemos primero en Google. Las llamadas no paran.',
  author: 'Ana L.',
  business: 'Taller La Confianza, Dallas'
}];
export function SocialProofSection() {
  return <section className="py-20 bg-pure-black border-t border-white/5" data-id="element-284">
      <div className="container mx-auto px-6" data-id="element-285">
        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20" data-id="element-286">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-287">
              <div className="text-4xl md:text-5xl font-black text-electric-yellow mb-2" data-id="element-288">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-white font-medium uppercase tracking-wider" data-id="element-289">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-290">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-dark-gray rounded-xl p-8 border border-white/10 relative overflow-hidden" data-id="element-291">
              <div className="absolute top-0 left-0 w-1 h-full bg-electric-yellow opacity-70" data-id="element-292" />

              <div className="flex gap-1 mb-6" data-id="element-293">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-electric-yellow text-electric-yellow" data-id="element-294" />)}
              </div>

              <p className="text-white text-lg italic mb-6 leading-relaxed" data-id="element-295">
                "{testimonial.quote}"
              </p>

              <div data-id="element-296">
                <div className="text-electric-yellow font-bold" data-id="element-297">
                  {testimonial.author}
                </div>
                <div className="text-gray-400 text-sm" data-id="element-298">
                  {testimonial.business}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}